import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Loader as LoaderLayoutComponent,
  Card as SemanticCard,
  Table as SemanticTable,
} from 'semantic-ui-react';
import { Text as TextLayout } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  max-width: 100%;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Dropdown = styled(SemanticDropdown)``;

export const Centered = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const Loader = styled(LoaderLayoutComponent)`
`;

export const Card = styled(SemanticCard)`
  width: 100%;
`;

export const Table = styled(SemanticTable)`
  padding: 1em;
`;

export const Text = styled(TextLayout)``;
